import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import { IconTable } from '@atlaskit/editor-common/icons';
import { toolbarInsertBlockMessages as messages } from '@atlaskit/editor-common/messages';
import { useQuickInsertContext } from '@atlaskit/editor-common/quick-insert/use-quick-insert-context';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import ButtonItem from '@atlaskit/menu/button-item';

import type { TablePlugin, TablePluginOptions } from '../../tablePluginType';

import { insertTableFromQuickInsert } from './insertTableFromQuickInsert';

type Props = {
	api: ExtractInjectionAPI<TablePlugin> | undefined;
	isTableSelectorEnabled: boolean | undefined;
	options: TablePluginOptions;
};

export const TableQuickInsertMenuItem = ({
	api,
	isTableSelectorEnabled,
	options,
}: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const { editorView, item, select } = useQuickInsertContext();
	const onClick = useCallback(() => {
		select(({ insert, source }) =>
			insertTableFromQuickInsert({
				api,
				inputMethod: source,
				insert,
				isTableSelectorEnabled,
				options,
				state: editorView.state,
			}),
		);
	}, [api, editorView, isTableSelectorEnabled, options, select]);

	return (
		<div onMouseMove={item?.onMouseMove}>
			<ButtonItem
				aria-selected={item?.isSelected}
				description={formatMessage(messages.tableDescription)}
				iconBefore={<IconTable />}
				id={item?.id}
				isSelected={item?.isSelected}
				onClick={onClick}
				role="option"
			>
				{formatMessage(messages.table)}
			</ButtonItem>
		</div>
	);
};
